import { lazy, Suspense } from 'react';
import { useSignedAgreementsQuery } from '@/feature/agreement/query';
import { ContentContainer } from '../components/ContentContainer';

const AgreementContent = lazy(
  () => import('../../agreement/dialog/AgreementContent')
);

interface AgreementsProps {
  visible: boolean;
}

const Agreements = ({ visible }: AgreementsProps) => {
  const { data } = useSignedAgreementsQuery();
  const documentIds = data?.documents.map((d) => d.id) ?? [];

  return (
    <ContentContainer visible={visible}>
      <Suspense>
        <AgreementContent documentIds={documentIds} />
      </Suspense>
    </ContentContainer>
  );
};

export default Agreements;
